<template>
  <div :id="`modal-${modalId}`">
    <MadModal
      :id="modalId"
      :data-cy="`${modalId}-modal`"
      :options="options"
      @opened="onOpened"
      @closed="onClosed"
    >
      <div class="modal-body">
        <b-tabs
          v-model="tabIndex"
          no-key-nav
        >
          <template>
            <b-tab :title="`${this.$i18n.t('JSON.profiles')}`">
              <div class="v-table">
                <TableServer type="profiles" />
              </div>
            </b-tab>
            <b-tab :title="`${this.$i18n.t('JSON.add-profile')}`">
              <ProfileForm v-if="fetcherAdminSchemas.forms['Profile']" />
            </b-tab>
            <b-tab
              v-if="profileId !== null && fetcherAdminProfile.id > 0"
              :title="`${this.$i18n.t('JSON.profile')}#${profileId}`"
            >
              <ProfileForm
                v-if="fetcherAdminSchemas.forms['Profile']"
                :profile="fetcherAdminProfile"
                mode="edit"
              />
            </b-tab>
          </template>
        </b-tabs>
      </div>
    </MadModal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import formHelpers from '@/mixins/admin/helpers/form-helpers';
import modalHelpers from '@/mixins/admin/helpers/modal-helpers';

export default {


  components: {
    MadModal: () => import('@/components/MadModal'),
    ProfileForm: () => import('@/components/admin/fetcher/modals/forms/ProfileForm'),
  },

  mixins: [
    formHelpers, //
    modalHelpers,
  ],

  props: {
    profileId: {
      type: Number,
      default: () => 0,
    },
  },

  data() {
    return {
      options: {
        width: '75%',
        //   height: '95%',
      },
    };
  },

  computed: {
    ...mapState({
      fetcherAdminProfile: (state) => state.fetcherAdminProfile.fetcherAdminProfile,
    }),

    modalId() {
      return 'profile';
    },
  },

  watch: {
    profileId(newValue) {
      if (newValue !== null) {
        this.loadFetcherAdminProfile();
      }
    },
  },

  methods: {
    ...mapActions(['getFetcherAdminProfile']),

    async loadFetcherAdminProfile() {
      try {
        await this.getFetcherAdminProfile({
          params: {
            pid: this.profileId,
          },
        });

        // console.log('profile', this.profile);

        // success
        // console.log('success loading profile!');
      } catch (error) {
        // error
        // console.log('error loading profile!');
      }
    },

    onOpened() {
      if (this.profileId !== null) {
        this.loadFetcherAdminProfile();
      }

      this.modalOpened();
    },

    onClosed() {
      this.modalClosed();
    },
  },
};
</script>
